import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "mb-0 h-full",
  style: {"position":"relative"}
}
const _hoisted_2 = { class: "overlay rounded-2xl" }
const _hoisted_3 = { class: "text-center mb-0" }
const _hoisted_4 = {
  ref: "tracking-area",
  class: "tracking-area mb-0"
}
const _hoisted_5 = {
  class: "canvas-container",
  ref: "canvas-container"
}
const _hoisted_6 = {
  class: "floating-rectangle",
  ref: "floating-rectangle"
}
const _hoisted_7 = {
  ref: "dialog",
  class: "rounded-lg p-6 max-w-sm w-full shadow-lg"
}
const _hoisted_8 = { class: "text-gray-800 mb-4" }
const _hoisted_9 = { class: "flex justify-end space-x-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_basic_button = _resolveComponent("basic_button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, _cache[2] || (_cache[2] = [
      _createElementVNode("div", { class: "text-center" }, [
        _createElementVNode("i", {
          style: {"position":"sticky","top":"33vh"},
          class: "fa-solid fa-spinner animate-spin"
        })
      ], -1 /* CACHED */)
    ]), 512 /* NEED_PATCH */), [
      [_vShow, $setup.dat_is_loading || $setup.file?.loading === true]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, null, 512 /* NEED_PATCH */),
        _createElementVNode("div", _hoisted_6, null, 512 /* NEED_PATCH */)
      ], 512 /* NEED_PATCH */)
    ], 512 /* NEED_PATCH */), [
      [_vShow, !$setup.dat_is_loading && $setup.file?.loading === false]
    ]),
    _createElementVNode("dialog", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, " Are you sure you want to delete page " + _toDisplayString($setup.dat_page_to_delete + 1) + "? ", 1 /* TEXT */),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_basic_button, {
          disabled: false,
          size: 'small',
          onClick: _cache[0] || (_cache[0] = $event => ($setup.cancel_delete_page()))
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode(" No ")
          ])),
          _: 1 /* STABLE */,
          __: [3]
        }),
        _createVNode(_component_basic_button, {
          class: "error",
          disabled: false,
          size: 'small',
          onClick: _cache[1] || (_cache[1] = $event => ($setup.confirm_delete_page()))
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [
            _createTextVNode(" Yes ")
          ])),
          _: 1 /* STABLE */,
          __: [4]
        })
      ])
    ], 512 /* NEED_PATCH */)
  ]))
}